<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="page_vii"></a><a id="cont"></a>Contents</h1>
<p class="toc0"><a href="#/05_authorsnote#note"><b>Author's Note</b></a></p>
<p class="toc0"><a href="#/06_introduction#intro"><b>Introduction</b></a></p>
<p class="toc1"><a href="#/07_chapter01#c01"><b>Chapter 1</b> The Art and Joy of Listening</a></p>
<p class="toc1"><span href="#/08_chapter02#c02" title="Link target outside of Sample"><b>Chapter 2</b> Become a Great Listener</span></p>
<p class="toc1"><a id="page_viii"></a><span href="#/09_chapter03#c03" title="Link target outside of Sample"><b>Chapter 3</b> Ask Powerful Questions</span></p>
<p class="toc1"><span href="#/10_chapter04#c04" title="Link target outside of Sample"><b>Chapter 4</b> Develop Others' Best Thinking</span></p>
<p class="toc1"><span href="#/11_chapter05#c05" title="Link target outside of Sample"><b>Chapter 5</b> The Art of Acknowledging and Inspiring</span></p>
<p class="toc1"><span href="#/12_chapter06#c06" title="Link target outside of Sample"><b>Chapter 6</b> Wise and Thoughtful Delegation</span></p>
<p class="toc1"><span href="#/13_chapter07#c07" title="Link target outside of Sample"><b>Chapter 7</b> Consistent Accountability</span></p>
<p class="toc0"><span href="#/14_conclusion#conc" title="Link target outside of Sample"><b>Conclusion</b></span></p>
<p class="toc0"><span href="#/15_appendix#app" title="Link target outside of Sample"><b>Appendix</b></span></p>
<p class="toc0"><span href="#/16_notes#notes" title="Link target outside of Sample"><b>Notes</b></span></p>
<p class="toc0"><span href="#/17_index#ind" title="Link target outside of Sample"><b>Index</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?b2347a16